module.exports = __webpack_public_path__ + "img/load-icon.7376dbaa.gif";